/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import type { RtdModuleConfig } from './types/prebid';

const ENDPOINTS_ORIGIN = 'https://nodals.io';
const TRAINING_ENDPOINTS_ORIGIN = 'https://t.nodals.io';

class Config {
  private static config: RtdModuleConfig | null = null;
  private static readonly DEFAULTS: Partial<RtdModuleConfig> = {
    params: {
      propertyId: '',
      endpoint: {
        origin: ENDPOINTS_ORIGIN,
      },
      lib: {
        debug: false,
        logLevel: 'error',
        analytics: {
          enabled: true,
          endpoint: {
            origin: ENDPOINTS_ORIGIN,
            trainingOrigin: TRAINING_ENDPOINTS_ORIGIN,
          },
        },
      },
    },
  };

  public static initialise(config: RtdModuleConfig): void {
    if (!Config.config) {
      Config.config = Config.deepMerge(Config.DEFAULTS, config) as RtdModuleConfig;
    }
  }

  private static deepMerge(defaults: any, config: any): any {
    const result = { ...defaults };
    
    for (const key in config) {
      if (config[key] !== null && typeof config[key] === 'object' && !Array.isArray(config[key])) {
        result[key] = Config.deepMerge(result[key] || {}, config[key]);
      } else {
        result[key] = config[key];
      }
    }
    
    return result;
  }

  public static get(): RtdModuleConfig {
    return Config.config as RtdModuleConfig;
  }
}

export default Config;
